import {ICompanySyncstep, IExportFlow, IExportTemplate, IObjectType, IRuleset} from "../../index";
import {ErrorObject} from "../../error/ErrorObject";
import {ErrorManager} from "../../error/ErrorManager";
import {Tab} from "../tab-list/Tab";
import {nsParentPath} from "./parentpath/fn";
import {nsRule} from "../ruleset/mutable/rule/nsRule";
import TYPE = nsParentPath.TYPE;

/** Snapshot used while creating/editing; nullable fields match empty form state. */
type IExportTemplateOriginal = Omit<IExportTemplate, 'id' | 'name' | 'objecttype' | 'ruleset' | 'syncstep'> & {
    id: number | null;
    name: string | null;
    objecttype: IObjectType | null;
    ruleset: IRuleset | null;
    syncstep: ICompanySyncstep | null;
};

interface IExportTemplateMutable {
    $original: IExportTemplateOriginal;

    active: KnockoutObservable<boolean>
    daysbeforepermanentdelete: KnockoutObservable<number>
    deletefiles: KnockoutObservable<boolean>
    description: KnockoutObservable<string>
    editstriggerfullevaluation: KnockoutObservable<boolean>
    exportflow: KnockoutObservableArray<IExportFlowMutable>
    name: KnockoutObservable<string>
    objecttype: KnockoutObservable<IObjectType | null>
    ruleset: KnockoutObservable<IRuleset | null>
    syncstep: KnockoutObservable<ICompanySyncstep | null>,
}

interface IExportFlowMutable {
    $original: IExportFlow
    expression: KnockoutObservable<string>
    nullable: KnockoutObservable<boolean>
    objecttype: KnockoutObservable<IObjectType | null>
    ruleset: KnockoutObservable<IRuleset | null>
    sourceattribute: KnockoutObservable<any> // IExportAttribute | string
    syncnext: KnockoutObservable<boolean>
    targetattribute: KnockoutObservable<any> // IExportAttribute | ISyncField | string
    targetAttributeMode: KnockoutObservable<nsRule.InputMode>
    type: KnockoutObservable<TYPE | undefined>
    updateforcesdeltasync: KnockoutObservable<boolean>
    errExpression: ErrorObject
    errRuleset: ErrorObject
    errSourceAttribute: ErrorObject
    errTargetAttribute: ErrorObject
    errType: ErrorObject
}

type TSynchronizeTemplateSections = 'general' | 'flowsexport' | 'flowsimport' | 'parentpath' | 'visma';

type TSynctemplateTabId = 'synctemplateinfo' | 'synctemplateparentpath' | 'synctemplatevisma' | 'synctemplateexportmappings' | 'synctemplateimportmappings'

type TTabs = {
    [Property in TSynctemplateTabId]: Tab
}

type TErrorManagers = {
    [Property in TSynctemplateTabId]: ErrorManager
}
